<template>
  <div class="w-full">
    <div class="vx-row" v-if="status == 'not-register'">
      <div class="vx-col w-full flex justify-end">
        <vs-button
          color="primary"
          class="mb-5"
          icon-pack="feather"
          icon="icon-edit "
          type="filled"
          to="/antrian-online/ambil-antrian"
        >Ambil Antrian</vs-button>
      </div>
    </div>
    <!-- Active Queue -->
    <div class="vx-row">
      <h3 class="vx-col w-full mb-5" v-if="listActiveQueue.length > 0">Antrian Aktif</h3>
      <div
        class="vx-col w-full cursor-pointer md:w-1/2"
        v-for="(item,index) in listActiveQueue"
        :key="index"
        @click="redirectTo('detail-antrian',item.registration_code)"
      >
        <vs-card class="ticket">
          <div slot="header">
            <div class="vx-row flex justify-between items-center m-2">
              <div class="flex-initial pr-3">
                <img
                  :src="item.logo | agencyLogo"
                  width="50px"
                  alt
                />
              </div>
              <div class="flex-1">
                <h4 class>{{item.service_name}}</h4>
                <div class="text-grey-dark">{{item.agency_initial == null ? item.agency_name : item.agency_initial}}</div>
              </div>
            </div>
          </div>
          <div class="flex flex-col">
            <div class="w-full flex justify-between">
              <div class="flex flex-1 flex-col">
                <div class="vx-col  py-2 flex text-lg">
                  <div class="flex-initial pr-3">
                    <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-activity" />
                  </div>
                  <div class="flex-1">{{item.registration_code}} 
                  </div>
                </div>
                <div class="vx-col  py-2 flex text-lg">
                  <div class="flex-initial pr-3">
                    <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-calendar" />
                  </div>
                  <div class="flex-1">{{item.date_book}}</div>
                </div>
                
              </div>
              <div class="flex  flex-col">
                <div class="vx-col  py-2 flex  text-lg">
                  <div class="flex-initial pr-3">
                    <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-user" />
                  </div>
                  <div class="">{{item.is_priority == 1 ? 'Mandiri' : 'Kuasa'}}</div>
                </div>
                <div class="vx-col  py-2 flex   text-lg">
                  <div class="flex-initial pr-3">
                    <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-clock" />
                  </div>
                  <div class="">{{item.start_time}} - {{item.end_time}}</div>
                </div>
              </div>
            </div>
            <div class="vx-col w-full py-2 flex  text-lg">
                <div class="">
                  <vs-chip :class="item.queue_status_chip+' text-white'">{{ item.queue_status_view }}</vs-chip>
                </div>
              </div>
          </div>
        </vs-card>
      </div>
    </div>

    <!-- Queue History -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-row m-2 mb-5">
          <h3 class="w-full">Riwayat Antrian</h3>
        </div>
      </div>
      <div class="vx-col w-full">
        <div class="vx-row m-2 mb-5">
          <div class="w-full flex justify-end">
            <vs-button
              icon-pack="feather"
              type="border"
              icon="icon-filter"
              class="mr-3"
              @click="isFilter = !isFilter"
              >Filter
            </vs-button>
            <vs-input
              icon-pack="feather"
              icon="icon-search"
              placeholder="Cari Kode Registrasi"
              v-model="registrationCode"
            />
          </div>

          <vx-card title="Filter Berdasarkan" class="my-5" v-if="isFilter">
            <div class="w-full flex flex-col md:flex-row">
              <div class="w-full md:w-1/3 px-3 mb-4">
                <div class="mb-2">Instansi / Dinas</div>
                <v-select :options="agencies" v-model="agencyId" />
              </div>
              <div class="w-full md:w-1/3 px-3">
                <div class="mb-2">Layanan</div>
                <v-select :options="services" v-model="serviceId" />
              </div>
              <div class="w-full md:w-1/3 px-3">
                <div class="mb-2">Status</div>
                <v-select :options="bookingStatusList" v-model="bookingStatus" />
              </div>
            </div>
            <br><hr><br>
            <div class="w-full flex flex-col md:flex-row">
              <div class="w-full md:w-1/3 px-3 mb-4">
                <div class="mb-2">Dari Tanggal</div>
                <datepicker v-model="startDate" :format="'yyyy-MM-dd'" placeholder="Dari Tanggal" />
              </div>
              <div class="w-full md:w-1/3 px-3">
                <div class="mb-2">Sampai Tanggal</div>
                <datepicker v-model="endDate" :format="'yyyy-MM-dd'" placeholder="Sampai Tanggal" />
              </div>
              <div class="w-full md:w-1/3 px-3">
                <div class="mb-2">.</div>
                <vs-button
                  icon-pack="feather"
                  type="border"
                  color="grey"
                  text-color="black"
                  icon="icon-refresh-ccw"
                  class="mr-3"
                  @click="resetFilterDate()"
                  >Reset Tanggal</vs-button
                >
              </div>
            </div>
          </vx-card>

          <global-new-wrapper
            :loading="tableLoading"
            :loadingType="'OneLine'"
            :loadingList="5"
            :empty="listHistoryQueue.data.length == 0"
            :error="false"
          >
            <global-table
              @reloadData="handleOnReloadData($event)"
              :currentPage="listHistoryQueue.current_page"
              :totalPage="listHistoryQueue.last_page"
            >
              <template #thead>
                <global-th width="20px">No.</global-th>
                <global-th>Kode Registrasi</global-th>
                <global-th>Waktu Kunjungan</global-th>
                <global-th>Layanan</global-th>
                <global-th>Instansi</global-th>
                <global-th>Status</global-th>
                <global-th>Action</global-th>
              </template>
              <template #tbody>
                <global-tr v-for="(item, index) in listHistoryQueue.data" :key="index">
                  <global-td>{{ index+1}}</global-td>
                  <global-td>{{ item.registration_code }}</global-td>
                  <global-td>
                    {{ moment(item.date_book).format('DD MMM YYYY') }} <br/>
                    {{ `${item.start_time} - ${item.end_time}` }}
                  </global-td>
                  <global-td>{{ item.service_name }}</global-td>
                  <global-td>{{ item.agency_initial ? item.agency_initial : item.agency_name }}</global-td>
                  <global-td>
                    <BookingStatusChip :status="item.booking_status"/>
                  </global-td>
                  <global-td>
                    <vs-button
                      @click="redirectTo('detail-history-antrian',item.registration_code)"
                      type="border"
                      color="primary"
                      size="small"
                      icon-pack="feather"
                      icon="icon-eye"
                    >Detail</vs-button>
                  </global-td>
                </global-tr>
              </template>
            </global-table>
          </global-new-wrapper>
        </div>
      </div>
    </div>

    <vs-popup class="holamundo" title :active.sync="popupQueue">
      <div class="vx-row">
        <div class="vx-col w-full text-center">
          <feather-icon
            icon="AwardIcon"
            class="p-6 my-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
        </div>
        <div
          class="vx-col w-full text-center text-4xl font-semibold text-primary"
        >Halo {{user.name}}</div>
        <div
          class="vx-col w-full text-center text-2xl font-semibold"
        >Antrian Anda Telah Dipanggil</div>
        <div class="flex flex-col w-full justify-center p-5">
          <div class="w-full text-center font-medium text-4xl">{{popupQueueData.counter}}</div>
          <div class="w-full text-center text-lg">{{popupQueueData.service_name}}</div>
          <div class="w-full text-center flex flex-col py-5">
            <span class="text-6xl text-primary">{{popupQueueData.ticket_code}}</span>
          </div>
          <div
            class="w-full text-center text-base"
          >Silahkan menuju {{popupQueueData.counter}} untuk mendapatkan layanan {{popupQueueData.service_name}}</div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import vSelect from 'vue-select'
import moment from "moment";
import BookingStatusChip from "@/components/chip/BookingStatusChip";
import _ from "lodash";

export default {
  components: {
    Datepicker,
    'v-select': vSelect,
    BookingStatusChip
  },
  data() {
    return {
      date: "",
      status: "not-register",
      popupQueueData : [],
      popupQueue: false,
      color: ["primary", "warning", "success"],
      listActiveQueue: [],
      listHistoryQueue: {
        data: []
      },
      registrationCode: '',
      startDate : '',
      endDate : '',
      services : [],
      agencies : [],
      serviceId: {
        value: "",
        label: "SEMUA LAYANAN"
      },
      agencyId: {
        value: "",
        label: "SEMUA INSTANSI"
      },
      bookingStatus: {
        value: "",
        label: "SEMUA STATUS"
      },
      bookingStatusList: [{
          value: "",
          label: "SEMUA STATUS"
        },
        {
          value: "registered",
          label: "TEREGISTER"
        },
        {
          value: "finished",
          label: "SELESAI"
        },
        {
          value: "canceled",
          label: "DIBATALKAN"
        },
        {
          value: "expired",
          label: "KADALUARSA"
        }
      ],
      tableLoading: true,
      isFilter: false,
      moment: this.moment,
      pagination: {
        currentPage: 1,
        perPage: 10
      }
    };
  },
  computed: {
    user() {
      return this.$store.state.AppActiveUser;
    }
  },
  watch: {
    startDate() {
      this.endDate != '' ? this.getQueueHistory() : '';
    },
    endDate() {
      this.startDate != '' ? this.getQueueHistory() : '';
    },
    serviceId() {
      if(this.serviceId == null){
        this.serviceId = { value: "-", label: "SEMUA SEMUA LAYANAN"};
      }
      this.getQueueHistory();
    },
    agencyId() {
      this.serviceId = {value: "-",label: "SEMUA LAYANAN"}
      if(this.agencyId == null){
        this.agencyId = { value: "-", label: "SEMUA INSTANSI"};
      }
      this.getQueueHistory();
    },
    bookingStatus() {
      this.getQueueHistory();
      if(this.bookingStatus == null){
        this.bookingStatus = { value: "-", label: "SEMUA STATUS"};
      }
    },
    registrationCode: _.debounce(function (query) {
      this.getQueueHistory(query);
    }, 500),
  },
  mounted() {
    this.getActiveQueue();
    this.getQueueHistory();
  },
  methods: {
    getActiveQueue() {
      var self = this;
      self.$vs.loading();
      self.$http.get(`/app/queue/active-queue`)
      .then(r => {
        self.listActiveQueue = r.data.data.active_queue;
        if(self.listActiveQueue.length != 0){
          self.listActiveQueue.forEach(function (item){
            item.status == 'registered' ? self.initQueueEcho(item.service_id) : '';
          });
        }
      })
      .catch(e => {
        self.parseError(e);
      })
      .finally(() => {
        self.$vs.loading.close();
      });
    },
    getQueueHistory(){
      this.tableLoading = true;
      let data = {
        start_date : this.startDate != '' ? moment(this.startDate).format('YYYY-MM-DD') : '',
        end_date : this.endDate != '' ? moment(this.endDate).format('YYYY-MM-DD') : '',
        service_id : this.serviceId.value,
        agency_id: this.agencyId.value,
        booking_status: this.bookingStatus.value,
        page: this.pagination.currentPage,
        registration_code: this.registrationCode
      };

      this.$http
      .get(`/app/queue/history`,{params : {...data}})
      .then(r => {
        this.listHistoryQueue = r.data.data.queue_history;
        this.tableLoading = false;
        this.services = r.data.data.services;
        this.agencies = r.data.data.agencies;
      })
      .catch(e => {
        this.parseError(e);
        this.tableLoading = false;
      });
    },
    redirectTo(urlName, parameter) {
      this.$router.push({
        name: urlName,
        params: { registration_code: parameter }
      });
    },
    formatterDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    initQueueEcho(serviceId) {
      var self = this;
      self.$echo
      .private(`Customer.Queue.${serviceId}`)
      .listen(".OnUpdateServiceQueueEvent", e => {
        if(self.$route.name == 'antrian-online'){
          if(e.data.type == 'call'){
            self.popupQueue = true;
            self.popupQueueData = e.data;
            window.setTimeout(function(){ 
              self.popupQueue = false;
            },2000);
            window.setTimeout(function(){ 
              self.$router.push({ name: "detail-antrian", params : {registration_code : e.data.registration_code} });
            },2300);
          }
          else if(e.data.type == 'finish'){
            self.$router.push({ name: "detail-antrian", params : {registration_code : e.data.registration_code} });
          }
          else{
            self.getActiveQueue();
          }
        }
      });
    },
    handleOnReloadData(currentPage) {
      this.pagination.currentPage = currentPage;
      this.getQueueHistory();
    },
    resetFilterDate(){
      this.startDate = "";
      this.endDate = "";
      this.getQueueHistory();
    }
  }
};
</script>